export default "__VITE_ASSET__fd84ce2f__"